import React from 'react';
import CustomQueryEditor from '../components/CustomQueryEditor';
import { AlertTriangle, Info } from 'lucide-react';

export default function CustomQuery() {
  return (
    <div className="space-y-6">
      <div className="flex items-start gap-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
        <Info className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="font-medium text-amber-900">Custom Query Interface</h4>
          <p className="text-sm text-amber-700 mt-1">
            This interface allows you to run custom SQL queries against your Redshift data warehouse.
            Use the sample queries as templates or write your own SELECT statements.
          </p>
        </div>
      </div>

      <div className="flex items-start gap-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
        <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="font-medium text-amber-900">Security Notice</h4>
          <p className="text-sm text-amber-700 mt-1">
            Only SELECT queries are permitted. INSERT, UPDATE, DELETE, and other data modification
            statements are blocked for security. Complex queries may take longer to execute.
          </p>
        </div>
      </div>

      <CustomQueryEditor />
    </div>
  );
}
